import {HttpEvent, HttpEventType, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {CookiesManager} from "../../cookies";
import {TOKEN_HEADER} from "../../../../../common/constants";
import {Router} from "@angular/router";
import {Injectable} from "@angular/core";

@Injectable()
export class BOHttpClientInterceptor implements HttpInterceptor {
    private static readonly UNAUTHORIZED_PAGE = '/space/unauthorized';

    /**
     * Request-only marker (never sent to the server): a 403 on this request reaches the caller's error callback
     * without leaving the screen. For optional calls of a page (e.g. whether to show an action button).
     */
    public static readonly NO_FORBIDDEN_REDIRECT_HEADER = 'X-BO-No-Forbidden-Redirect';

    constructor(private _router: Router) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
        const redirectOnForbidden = !req.headers.has(BOHttpClientInterceptor.NO_FORBIDDEN_REDIRECT_HEADER);
        return next.handle(this.modifyRequest(req))
            .pipe(
                map(this.onResponseCallback()),
                catchError(this.onResponseErrorCallback(redirectOnForbidden))
            );
    }

    private modifyRequest(request: HttpRequest<any>): HttpRequest<any> {
        return request.clone({
            headers: this.setRequestHeaders(request).delete(BOHttpClientInterceptor.NO_FORBIDDEN_REDIRECT_HEADER)
        });
    }

    private onResponseCallback() {
        return (response: HttpEvent<any>): HttpEvent<any> => {
            switch (response.type) {
                case HttpEventType.Response:
                    this.trySaveTokenHeader(response.headers);
                    break;
            }
            return response;
        }
    }

    private onResponseErrorCallback(redirectOnForbidden: boolean) {
        return (error): any => {
            if (error.status === 403 && redirectOnForbidden) {
                this._router.navigate([BOHttpClientInterceptor.UNAUTHORIZED_PAGE]);
            }
            return Observable.throw(error);
        }
    }

    private setRequestHeaders(req: HttpRequest<any>): HttpHeaders {
        let headers = req.headers;

        if (CookiesManager.isTokenExist()) {
            headers = headers.set(TOKEN_HEADER, CookiesManager.getToken());
        }

        return headers;
    }

    private trySaveTokenHeader(headers: HttpHeaders) {
        if (headers.has(TOKEN_HEADER)) {
            CookiesManager.setToken(headers.get(TOKEN_HEADER));
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/http/client/bo.http.interceptor.ts